const Barba = require('Barba');
import * as animations from "../animations";

export const BarbaReplaceTransition = Barba.BaseTransition.extend({
    start: function() {
        this.newContainerLoading.then(this.finish.bind(this));
    },

    finish: function() {
        document.body.scrollTop = 0;
        window.pew.enhanceRegistry(this.newContainer);
        this.done();
    }
});
